import React from "react";
import { Layout, Menu } from "antd";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Config from "config/routes";
import MaterialIcon from "components/common/MaterialIcon";
import PropTypes from "prop-types";
import Avatar from "components/common/Avatar";
import uuidv1 from "uuid/v1";

@withRouter
@connect((state) => ({
  currentUser: state.Auth.currentUser,
  company: state.General.company,
}))
@autobind
/**
 *
 */
export default class Drawer extends React.PureComponent {
  
  static propTypes = {
    company: PropTypes.object,
    collapsed: PropTypes.bool,
    match: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    currentUser: PropTypes.object,
  };

  static defaultProps = {
    collapsed: false,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
    };
  }

  /**
   *
   * @param {Boolean} collapsed
   */
  onCollapse(collapsed) {
    this.setState({ collapsed });
  }

  /**
   *
   * @param {Object} item
   */
  onMenuClick({ key }) {
    const { location, history } = this.props;

    // if (/^path::./.test(key)) {
    const path = key.substring(6);

    if (!location.pathname.equals(path)) {
      history.push(path);
    }
    // }
  }

  /**
   *
   * @param {Array} routes
   * @param {Object} path
   * @param {String} parentIds
   * @return {Array}
   */
  _getRoutes(routes, path = "", parentIds = "") {
    const { currentUser } = this.props;
    let _routes = [];
    let isAdmin = currentUser && currentUser.id && currentUser.id === 1;
    routes.forEach((route) => {
      let _path = path;
      const id =
        route.id && route.id
          ? route.id
          : route.path
          ? route.path
          : false
          ? route.icon
          : uuidv1();

      let _checkIsNotAdmin = -1;
      let _checkIsAdmin = -1;
      if (route.permissions) {
        _checkIsNotAdmin = route.permissions.findIndex(
          (item) => item === "isNotAdmin"
        );
        _checkIsAdmin = route.permissions.findIndex(
          (item) => item === "isAdmin"
        );
      }

      // if (route.icon) {
      if (route.drawer) {
        if (route.path) {
          _path = `${_path}/${route.path}`;
        }        // Show in admin panel only if it doesn't have isNotAdmin permission
        if (app.isAdmin() && _checkIsNotAdmin === -1) {
          if (app._.isEmpty(route.routes)) {
            _routes.push(
              <Menu.Item
                key={`path::${_path}`}
              >
                <MaterialIcon
                  name={app.haveMenu(route.permissions) ? route.icon : "lock"}
                  style={{
                    fontSize: "1.2rem",
                  }}
                />
                <span>{route.name}</span>
              </Menu.Item>
            );
          } else {
            _routes.push(
              !route.notShow && (
                <Menu.SubMenu
                  key={`item${parentIds}-${id}`}
                  title={[
                    <MaterialIcon
                      key={0}
                      name={
                        app.haveMenu(route.permissions) ? route.icon : "lock"
                      }
                      style={{
                        fontSize: "1.2rem",
                      }}
                    />,
                    <span key={1}>{route.name}</span>,
                  ]}
                >
                  {this._getRoutes(route.routes, _path, `${parentIds}-${id}`)}
                </Menu.SubMenu>
              )
            );
          }
        }        // For regular users, show menu items normally (including isNotAdmin ones)
        // We specifically need to show items with "isNotAdmin" permission for non-admin users
        if (!app.isAdmin() && (_checkIsNotAdmin !== -1 || app.haveMenu(route.permissions))) {
          if (app._.isEmpty(route.routes)) {
            _routes.push(
              <Menu.Item
                key={`path::${_path}`}
              >
                <MaterialIcon
                  name={_checkIsNotAdmin !== -1 ? route.icon : (app.haveMenu(route.permissions) ? route.icon : "lock")}
                  style={{
                    fontSize: "1.2rem",
                  }}
                />
                <span>{route.name}</span>
              </Menu.Item>
            );
          } else {
            _routes.push(
              <Menu.SubMenu
                key={`item${parentIds}-${id}`}
                title={[
                  <MaterialIcon
                    key={0}
                    name={_checkIsNotAdmin !== -1 ? route.icon : (app.haveMenu(route.permissions) ? route.icon : "lock")}
                    style={{
                      fontSize: "1.2rem",
                    }}
                  />,
                  <span key={1}>{route.name}</span>,
                ]}
              >
                {this._getRoutes(route.routes, _path, `${parentIds}-${id}`)}
              </Menu.SubMenu>
            );
          }
        }
      }
    });

    return _routes;
  }

  /**
   *
   * @param {Array} routes
   * @param {Array} current
   * @param {String} parentIds
   * @param {Number} count
   * @return {Array}
   */
  getOpenKeys(routes, current, parentIds = "", count = 0) {
    const _keys = [];

    routes.forEach((route) => {
      if (route.icon) {
        const id =
          route.id && route.id
            ? route.id
            : route.path
            ? route.path
            : route.icon
            ? route.icon
            : uuidv1();

        if (current.indexOf(route.path) === count) {
          if (!route.routes.isEmpty()) {
            _keys.push(`item${parentIds}-${id}`);
            _keys.push(
              ...this.getOpenKeys(
                route.routes,
                current,
                `${parentIds}-${id}`,
                ++count
              )
            );
          }
        }
      }
    });

    return _keys;
  }

  /**
   *
   * @return {Array}
   */
  get defaultOpenKeys() {
    const _current = this.props.location.pathname.substring(1).split("/");

    return this.getOpenKeys(Config.routes.home, _current);
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { location, company } = this.props;
    let state = Object.assign(
      {},
      {
        backgroundColor: { hex: "#404040" },
        organizationChart: "chart",
      },
      app.local.load("app")
    );
    console.log("Config.routes.home", Config.routes.home);

    return (
      <Layout.Sider
        collapsible
        collapsed={this.state.collapsed}
        onCollapse={this.onCollapse}
        className="drawer"
        width={256}
        style={{
          background: "#000",
        }}
      >
        <div
          className="companyInfo"
          style={{
            background: state.backgroundColor.rgb
              ? `rgba(${state.backgroundColor.rgb.r},${state.backgroundColor.rgb.g},${state.backgroundColor.rgb.b},0.5)`
              : state.backgroundColor.hex,
          }}
        >
          {app.can("isAdmin") ? (
            <Link
              to={"/company-setting"}
              style={{ textDecoration: "none", color: "#fff" }}
            >
              <span
                style={{
                  border: "2px solid rgba(255, 255, 255, .67)",
                  borderRadius: "50%",
                  display: "inline-grid",
                }}
              >
                <Avatar src={company.logo} size="large" text={company.name} />
              </span>
              <br />
              <span className="companyName">{company.name}</span>
            </Link>
          ) : (
            <div>
              <span
                style={{
                  border: "2px solid rgba(255, 255, 255, .67)",
                  borderRadius: "50%",
                  display: "inline-grid",
                }}
              >
                <Avatar src={company.logo} size="large" text={company.name} />
              </span>
              <br />
              <span className="companyName">{company.name}</span>
            </div>
          )}
        </div>

        <style>
          {`.ant-tooltip-inner, .ant-layout-header, .ant-menu-dark, .ant-menu-dark .ant-menu-sub, .ant-layout-sider-trigger{background: ${
            state.backgroundColor.rgb
              ? `rgba(${state.backgroundColor.rgb.r},${state.backgroundColor.rgb.g},${state.backgroundColor.rgb.b},1)`
              : state.backgroundColor.hex
          }}`}
        </style>
        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={[`path::${location.pathname}`]}
          defaultOpenKeys={this.defaultOpenKeys}
          // openKeys={this.defaultOpenKeys}
          style={{
            height: "100%",
            borderRight: 0,
            background: state.backgroundColor.rgb
              ? `rgba(${state.backgroundColor.rgb.r},${state.backgroundColor.rgb.g},${state.backgroundColor.rgb.b},0.8)`
              : state.backgroundColor.hex,
          }}
          className="drawer-menu"
          onClick={this.onMenuClick}
        >
          {this._getRoutes(Config.routes.home)}
        </Menu>
      </Layout.Sider>
    );
  }
}
